<script setup>
import {onBeforeUnmount, onBeforeMount, ref, computed} from "vue";
import { useStore } from "vuex";
import {useRouter} from "vue-router";
import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import {ElNotification} from "element-plus";

const body = document.getElementsByTagName("body")[0];
const email = ref('');
const password = ref('');
const remember = ref(false);
import Cookies from "js-cookie";
const router = useRouter();
const store = useStore();
const IsWorking = ref(false);
const updateAdmin = (payload) => {
  store.dispatch("updateCurrAdmin", payload);
};

onBeforeMount(() => {

  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});
// const currAdmin = computed(() => store.state.currAdmin);

async function DoLogin(){
  IsWorking.value=true;
    const response = await fetch('https://inv.tvcnews.co/endPoint/doLogin.php',{
      method:"POST",
      headers:{
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization':'Bearer '
      },
      body:JSON.stringify({
        password:password.value,
        email:email.value
      })
    })
    const data = await response.json();
    IsWorking.value=false;
    if(data?.status===200){
      if(remember.value){
        Cookies.set('user_token',data.data.token, {expires:30});
      }else{
        Cookies.set('user_token',data.data.token, {expires:1});
      }

      updateAdmin(data?.data?.user);
      await router.push('./dashboard-default')
    }else{
      ElNotification({
        title: 'Warning',
        style:"font-family:tahoma",
        message: 'حساب کاربری مورد نظر یافت نشد',
        type: 'warning',
      })
    }
}
</script>
<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        />
      </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div
                style="font-family: Tahoma"
              class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0"
            >
              <div class="card card-plain">
                <div class="pb-0 card-header text-start" style="text-align: right">
                  <h4 class="font-weight-bolder" style="text-align: right">ورود به حساب کاربری</h4>
                  <p class="mb-0" style="text-align: right">ایمیل و رمز عبور خود را وارد کنید</p>
                </div>
                <div class="card-body">
                  <form role="form">
                    <div class="mb-3">
                      <argon-input
                          style="font-family: Tahoma"
                          v-model="email"
                        id="email"
                        type="email"
                        placeholder="ایمیل"
                        name="email"
                        size="lg"
                      />
                    </div>
                    <div class="mb-3">
                      <argon-input
                          style="font-family: Tahoma"
                        id="password"
                          v-model="password"
                        type="password"
                        placeholder="رمز عبور"
                        name="password"
                        size="lg"

                      />
                    </div>
                    <argon-switch v-model="remember" id="rememberMe" name="remember-me" style="font-family: Tahoma;direction: rtl;"
                      >اطلاعات را به خاطر بسپار</argon-switch
                    >

                    <div class="text-center">
                      <el-button type="primary" round :loading="IsWorking"
                                 @click="DoLogin()"
                                 size="large"

                                 style="font-family: Tahoma;width: 150px;margin: 10px"
                      >ورود</el-button>

                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm"> آیا حساب کاربری دارید؟
                    <a
                      href="javascript:;"
                      class="text-success text-gradient font-weight-bold"
                      >ثبت نام کنید</a
                    >
                  </p>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="
                  background-image: url(&quot;https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-ill.jpg&quot;);
                  background-size: cover;
                "
              >
                <span class="mask bg-gradient-success opacity-6"></span>
                <h4
                  class="mt-5 text-white font-weight-bolder position-relative "

                >
                  در سرمایه‌گذاری، فرصت‌های ساده و مطمئن نتیجه بررسی و تلاش‌های پنهان هستند
                </h4>
                <p class="text-white position-relative" style="direction: rtl;font-family: Tahoma">
                  برای سرمایه‌گذاری امن، به جزئیات پشت صحنه توجه کنید.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
